import Flex from "@/components/flex"
import MonitoringMinimap from "./_components/monitoring-minimap"
import MonitoringHistory from "./_components/monitoring-history"
import MonitoringRealtimeStatus from "./_components/monitoring-realtime-status"
import { useState } from "react"
import { useEffect } from "react"
import { useRef } from "react"
import { monitoringStore } from "./_components/monitoring-store"
import Wrapper from "@/components/wrapper"
import { useToggleStore } from "@/hooks/use-toggle-store"

const MonitoringPage = () => {
  const { aptMonitoringMap, summary } = monitoringStore()

  const [hoveredResource, setHoveredResource] = useState("")
  const [selectedDong, setSelecctedDong] = useState("all")
  const [selectedResource, setSelectedResource] = useState("")

  const { show } = useToggleStore("monitoring")

  const statusRef = useRef(null)
  const [statusHeight, setStatusHeight] = useState(0)

  useEffect(() => {
    if (!statusRef.current) return

    const result = statusRef.current.getBoundingClientRect()
    setStatusHeight(result.height)
  }, [])

  const dongClick = (dong) => {
    setSelecctedDong(selectedDong === dong ? "all" : dong)
    setSelectedResource("")
  }

  return (
    <div className="h-full">
      <Flex className="h-full">
        <Wrapper.shadow className="h-full flex-1 flex flex-col">
          <div className="mb-5">
            <h2 className="text-lg font-bold text-gray-800">세대별 모니터링</h2>

            <p className="mt-1 text-xs text-gray-400">
              동별 세대의 이상 상태를 한눈에 확인할 수 있습니다
            </p>
          </div>

          <div className="flex-1 overflow-y-auto pr-1">
            <article className="flex flex-wrap justify-start gap-4">
              {aptMonitoringMap &&
                Object.entries(aptMonitoringMap).map(([dong, unitMap]) => (
                  <button
                    key={dong}
                    className={`text-left rounded-2xl border-2 flex-1
                      bg-gray-50/50 hover:bg-gray-50 p-4
                      ${
                        selectedDong === dong
                          ? "border-blue-500 bg-blue-50/40 shadow-sm"
                          : "border-gray-100 bg-gray-50/50 hover:border-gray-200/80 "
                      }
                      cursor-pointer
                    `}
                    onClick={() => dongClick(dong)}
                  >
                    <div className="mb-5 flex items-center justify-between">
                      <div>
                        <h3 className="text-sm font-bold text-gray-800">{dong}동</h3>

                        <p className="mt-0.5 text-[11px] text-gray-400">세대 모니터링</p>
                      </div>

                      <div className="flex items-center gap-2">
                        <div className="text-right">
                          <p className="text-[10px] text-gray-400">전체 세대</p>
                          <p className="text-sm font-semibold text-gray-700">
                            {summary[dong]?.totalHouseholds ?? 0}
                          </p>
                        </div>

                        <div className="h-7 w-px bg-gray-200" />

                        <div className="text-right">
                          <p className="text-[10px] text-gray-400">이상 세대</p>
                          <p
                            className={`text-sm font-semibold ${
                              summary[dong]?.abnormalHouseholds > 0
                                ? "text-red-500"
                                : "text-gray-400"
                            }`}
                          >
                            {summary[dong]?.abnormalHouseholds ?? 0}
                          </p>
                        </div>
                      </div>
                    </div>

                    <MonitoringMinimap
                      selectedState={selectedDong === "all" ? "all" : selectedDong === dong}
                      hoveredResource={hoveredResource}
                      unitMap={unitMap}
                    />
                  </button>
                ))}
            </article>
          </div>
        </Wrapper.shadow>
        <Flex className="flex-col min-w-80 h-full relative">
          <Wrapper.shadow className={"shrink-0 min-h-100"} ref={statusRef}>
            <MonitoringRealtimeStatus
              summary={summary}
              selectedDong={selectedDong}
              onHoverResource={setHoveredResource}
              selectedResource={selectedResource}
              onSelectResource={setSelectedResource}
            />
          </Wrapper.shadow>
          {statusHeight && (
            <Wrapper.shadow
              style={{ top: show ? 0 : statusHeight + 20 }} // gap : 20px
              className={`
              absolute w-full 
              flex-1 flex flex-col duration-300 bottom-0
              `}
            >
              <MonitoringHistory selectedDong={selectedDong} selectedResource={selectedResource} />
            </Wrapper.shadow>
          )}
        </Flex>
      </Flex>
    </div>
  )
}

export default MonitoringPage
